import { render, staticRenderFns } from "./ChangeMailContactModal.vue?vue&type=template&id=66481cdf&scoped=true&"
import script from "./ChangeMailContactModal.vue?vue&type=script&lang=ts&"
export * from "./ChangeMailContactModal.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeMailContactModal.vue?vue&type=style&index=0&id=66481cdf&scoped=true&lang=scss&"
import style1 from "./ChangeMailContactModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66481cdf",
  null
  
)

export default component.exports